import "babel-polyfill";
import "array-flat-polyfill";
import "./core/owl.carousel.min.js";
import "./core/theme.js";
import "../styles/theme.scss";
import "./minicart.js";
import "./size-chart.js";

import "./product-parent.js";
import "./product-page.js";

/**
* applySwatches: 
* @param  {[type]} swatches         array of swatch elements with data-value='[Color Name]'
* @param  {[type]} applyToSelector  query of child elements to apply background to
*/
window.applySwatches = function(swatches, applyToSelector) {
    swatches.each(function(index, swatch) {
        
        var swatchColorAttribute = swatch.dataset.value;
        var swatchColors = swatchColorAttribute.split(' & ');

        var swatchHexes = swatchColors.map(function(name) {
            return colors[name] || '#000';
        });

        var bg;

        if (swatchHexes.length === 1) {
            bg = swatchHexes[0];
        } else if (swatchHexes.length === 2) {
            bg = `linear-gradient(135deg, ${swatchHexes[0]} 50%, ${swatchHexes[1]} 50%)`;
        } else if (swatchHexes.length === 3) {
            bg = `linear-gradient(135deg, ${swatchHexes[0]} 40%, ${swatchHexes[1]} 40%, ${swatchHexes[1]} 60%, ${swatchHexes[2]} 60%)`;
        }

        // $(swatch).find(applyToSelector)[0].style.setProperty('--swatch', bg);
    });
}

Shopify.handleize = function(str) {
  return str
    .toLowerCase()
    .replace(/[^\w\u00C0-\u024f]+/g, "-")
    .replace(/^-+|-+$/g, "");
};
